<template>
  <div class="share-component">
    <div class="share-component__title h5 semibold">{{ title }}</div>
    <div class="share-component__buttons">
      <a
        v-for="(link, index) in links"
        :key="`link-${ index }`"
        :href="link.link"
        target="_blank"
        rel="nofollow noopener noreferrer"
      >
        <img :src="link.icon" />
      </a>
      <div @click="copyLink">
        <img
          src="~/assets/img/svg/common/copy.svg"
          alt="копировать"
        />
      </div>
    </div>
  </div>
</template>

<script setup lang="ts">
import { useAsset } from '~/composables/useAssets';
import { clipboardWriteText } from '~/utils/clipboard';

interface ILink {
	icon: string;
	link: string;
}

const props = defineProps<{
	title?: string;
}>();

const { $toast } = useNuxtApp();
const title = computed(() => {
  return props.title ? props.title : 'Поделиться:';
});
const links: ComputedRef<ILink[]> = computed(() => {
  const link: string = process.client ? window.location.href : '#';
  return [
    { icon: useAsset('img/svg/social-media/telegram.svg'), link: `https://telegram.me/share/url?url=${link}` },
    { icon: useAsset('img/svg/social-media/vk.svg'), link: `http://vk.com/share.php?url=${link}` },
    { icon: useAsset('img/svg/social-media/odnoklassniki.svg'), link: `https://connect.ok.ru/offer?url=${link}` },
    // { icon: useAsset('img/svg/social-media/viber.svg'), link: `viber://pa?chatURI=${link}` },
    { icon: useAsset('img/svg/social-media/max.svg'), link: `https://max.ru/:share?text=${link}` }
  ];
});
const copyLink = async () => {
  const link: string = process.client ? window.location.href : '#';
  const isSuccess = await clipboardWriteText(link);
  if (isSuccess) {
    $toast.success('Ссылка успешно скопирована.');
  }
};
</script>

<style scoped lang="scss">
.share-component {
}

.share-component__title {
	margin-bottom: 16px;
}

.share-component__buttons {
	display: flex;
	flex-wrap: wrap;
	margin-top: -16px;
	margin-left: -16px;

	& > * {
		display: flex;
		align-items: center;
		justify-content: center;
		width: 40px;
		height: 40px;
		margin-top: 16px;
		margin-left: 16px;
		border-radius: 8px;
		background: #EEEDED;
		padding: 4px;
		box-sizing: border-box;
		cursor: pointer;

		img {
			width: 100%;
			height: 100%;
			object-fit: contain;
		}

		&:hover {
			background: #404040;

			img {
				filter: invert(1);
			}
		}
	}
}
</style>
